import produce from 'immer';
import create from 'zustand';

const useBannerStore = create(set => ({
  banner: {
    id: null,
    name: null,
    image: null,
    imageFilename: null,
    imageContentType: null,
    imageUrl: null,
    headline: null,
    byline: null,
    registerButtonCopy: null,
  },
  errors: {},
  set: fn => set(produce(fn)),
}));

export default useBannerStore;
